<template>
  <div
    class="vu-confirm-overlay"
    :class="{ open }"
    role="dialog"
    aria-modal="true"
    :aria-hidden="open ? 'false' : 'true'"
    @click.self="$emit('keep')"
  >
    <div class="vu-confirm-box">
      <div class="vu-confirm-icon">
        <icon-info-circle
          :size="28"
          :stroke-width="2.2"
        />
      </div>
      <h3 class="vu-confirm-title">{{ t('cancel_title') }}</h3>
      <p class="vu-confirm-msg">{{ t('cancel_msg') }}</p>
      <div class="vu-confirm-actions">
        <button
          type="button"
          class="vu-confirm-btn cancel"
          @click="$emit('keep')"
        >
          {{ t('cancel_keep') }}
        </button>
        <button
          type="button"
          class="vu-confirm-btn destructive"
          @click="$emit('confirm')"
        >
          {{ t('cancel_abort') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { i18nMixin } from '../helpers';
import IconInfoCircle from '../../icons/IconInfoCircle.vue';

export default {
  name: 'CancelConfirmDialog',
  mixins: [i18nMixin],
  components: { IconInfoCircle },
  props: {
    open: { type: Boolean, default: false },
  },
};
</script>
